import { Counter } from "PFApp/components/counter";
import React from "react";
import { useTranslation } from "react-i18next";

import { SkillCounter, useSkillsManagementContext } from "../contexts/skills_management_context_provider";
import { useSkillManagementCounters } from "../hooks/use_skill_management_counters";
import css from "./skills_management_table_header.module.scss";

export const SkillsManagementTableCounters = () => {
  const { t } = useTranslation("skillsManagement", { keyPrefix: "table.counters" });
  const { setSelectedCounter, selectedCounter, setCurrentPage, setRowSelectionState } =
    useSkillsManagementContext();

  const counters = useSkillManagementCounters();

  const handleCounterClick = (counter: SkillCounter) => {
    setRowSelectionState({});
    setSelectedCounter(counter);
    setCurrentPage(1);
  };

  return (
    <div className={css.counters}>
      <Counter
        title={t(SkillCounter.All)}
        code={SkillCounter.All}
        selected={SkillCounter.All === selectedCounter}
        onClick={handleCounterClick}
        counter={counters.total}
        classes={{ button: css.counter }}
      />
      <Counter
        title={t(SkillCounter.Approvals)}
        code={SkillCounter.Approvals}
        selected={SkillCounter.Approvals === selectedCounter}
        onClick={handleCounterClick}
        counter={counters.created}
        classes={{ button: css.counter }}
      />
      <Counter
        title={t(SkillCounter.Blocked)}
        code={SkillCounter.Blocked}
        selected={SkillCounter.Blocked === selectedCounter}
        onClick={handleCounterClick}
        counter={counters.blocked}
        classes={{ button: css.counter }}
      />
      <Counter
        title={t(SkillCounter.Merged)}
        code={SkillCounter.Merged}
        selected={SkillCounter.Merged === selectedCounter}
        onClick={handleCounterClick}
        counter={counters.merged}
        classes={{ button: css.counter }}
      />
    </div>
  );
};
